import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import React, { useState, useEffect } from "react";
import HeroSectionImg from "../../assets/HeroSectionImg.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LoginDialog from '../../Components/CustomizedModels/LoginModel';
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function HeroSection() {
  const navigate = useNavigate();
  const [openLogin, setOpenLogin] = useState(false);

  const isMobile = useMediaQuery('(max-width:600px)');

  const features = [
    {
      icon: <AccessTimeIcon sx={{ fontSize: 40, color: "#fff" }} />,
      title: "Automated Alerts",
      description: "Get low-stock and reorder notifications.",
    },
    {
      icon: <CheckCircleIcon sx={{ fontSize: 40, color: "#fff" }} />,
      title: "Real-Time Inventory Tracking",
      description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    },
    {
      icon: <AccessTimeIcon sx={{ fontSize: 40, color: "#fff" }} />,
      title: "Production Traction",
      description: "Know what's in stock anytime, anywhere.",
    },
  ];
  const handleLoginOpen = () => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));


    if (userDetails) {
      if (userDetails?.role === 'admin') {
        navigate('/admin/dashboard');
      }
      else if (userDetails?.role === 'super_admin') {
        navigate('/superAdmin/dashboard');
      }
      else if (userDetails?.role === 'stock_manager') {
        navigate('/storemanager/stockmanagement');
      }
      else if (userDetails?.role === 'production_manager') {
        navigate('/productionmanager/dashboard');
      }
      else {
        navigate('/');
      }
    } else {
      setOpenLogin(true);
    }
  };

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem('userDetails'));

    if (userDetails) {
      if (userDetails?.role === 'admin') {
        navigate('/admin/dashboard');
      }
      else if (userDetails?.role === 'super_admin') {
        navigate('/superAdmin/dashboard');
      }
      else if (userDetails?.role === 'stock_manager') {
        navigate('/storemanager/stockmanagement');
      }
      else if (userDetails?.role === 'production_manager') {
        navigate('/productionmanager/dashboard');
      }
    }
  }, [navigate]);

  const handleLoginClose = () => {
    setOpenLogin(false);
  };

  const handleOtpLogin = () => {
    setOpenLogin(false);
  };
  const handleLoginSuccess = () => {
    toast.success('Logged in successfully');
    handleLoginClose();
  };

  const handleLoginError = (errorMessage) => {
    toast.error(errorMessage || 'Login failed');
    console.error('Login failed:', errorMessage);
  };
  return (
    <Box sx={{ backgroundColor: '#F6F8FF' }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: "space-between",
          padding: "50px",
          borderRadius: "10px",
          paddingTop: '5%',
          // overflow: 'hidden',
        }}
      >
        {/* Left Section - Text */}
        <Box sx={{ maxWidth: { xs: '100%', sm: "50%" }, marginLeft: { xs: '0%', sm: '10%' }, }}>
          <h1
            style={{
              color: "#031432",
              fontWeight: "bold",
              fontSize: "45px",
              lineHeight: "1.2",
              fontFamily: "Poppins",
            }}
          >
            Smart Inventory, Smarter Business
          </h1>
          <Typography sx={{ color: "#6B7280", marginTop: "10px", fontFamily: 'Sora' }}>
            Track, Manage & Optimize – All in One Place!
          </Typography>
          <Button
            sx={{
              marginTop: "20px",
              background: "linear-gradient(90deg, #3B82F6, #6366F1)",
              color: "#fff",
              padding: "10px 25px",
              borderRadius: "25px",
              fontWeight: "bold",
              fontSize: "16px",
              textTransform: "none",
              "&:hover": { opacity: 0.9, background: "#3B82F6" },
            }}
            onClick={handleLoginOpen}
          >
            Login
          </Button>
        </Box>

        {/* Right Section - Image */}
        <Box
          sx={{
            position: "relative",
            width: "300px",
            height: "300px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: { xs: '0%', sm: "10%" },
            marginBottom: "2%",
            marginTop: { xs: '15%', sm: '0%' }
          }}
        >
          {/* Blue Circle Background */}
          <Box
            sx={{
              width: isMobile ? "350px" : "400px",
              height: isMobile ? "350px" : "400px",
              marginTop: "53px",
              borderRadius: "50%",
              background: "linear-gradient(90deg, #3B82F6, #6366F1)",
              position: "absolute",
              zIndex: 0,
            }}
          />
          {/* Hero Image */}
          <img
            src={HeroSectionImg}
            alt="hero"
            style={{
              width: isMobile ? "390px" : "450px",
              height: isMobile ? "390px" : "450px",
              objectFit: "contain",
              position: "relative",
              zIndex: 1,
              borderBottomRightRadius: "50%",
              borderBottomLeftRadius: "50%",
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          padding: "20px",
          mt: "20px",
        }}
      >
        {features.map((feature, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              background: 'linear-gradient(145.08deg, #1678F2 3.73%, #65A8FB 132.69%)',
              borderRadius: "15px",
              padding: "10px",
              width: "300px",
              color: "#fff",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Icon */}
            {feature.icon}

            {/* Text Content */}
            <Box>
              <Typography sx={{ fontSize: "15px", fontWeight: "bold", fontFamily: 'Popppins' }}>
                {feature.title}
              </Typography>
              <Typography sx={{ fontSize: "12px", opacity: 0.9, fontFamily: 'Sora' }}>
                {feature.description}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
      <LoginDialog
        open={openLogin}
        onClose={handleLoginClose}
        // onForgotPassword={handleForgotPasswordOpen}
        onOtpLogin={handleOtpLogin}
        onLoginSuccess={handleLoginSuccess}
        onLoginError={handleLoginError}
      />
    </Box>
  );
}

export default HeroSection;
